// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyClTz1cMO0Rp5Sod3HnWZo_h4fwHyDSzo8",
    authDomain: "authentication-6e29a.firebaseapp.com",
    projectId: "authentication-6e29a",
    storageBucket: "authentication-6e29a.appspot.com",
    messagingSenderId: "505924582397",
    appId: "1:505924582397:web:a7c32e7ed842bea0ba7794"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;